export const SET_STUDENT_DATA = "SET_STUDENT_DATA";
